import _objectWithoutProperties from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["input"];
import KivaProxy from "@/utils/kivaProxy/src";
// import { CityTransformer } from '@/transformers/CityTransformer'

export default {
  name: "KvCitySelect",
  props: {
    value: {},
    country: {}
  },
  data: function data() {
    return {
      loading: false,
      mutableValue: this.value,
      cities: []
    };
  },
  methods: {
    input: function input() {
      this.$emit("input", this.mutableValue);
    }
  },
  computed: {
    attrs: function attrs() {
      return this.$attrs;
    },
    listeners: function listeners() {
      var _this$$listeners = this.$listeners,
        input = _this$$listeners.input,
        listeners = _objectWithoutProperties(_this$$listeners, _excluded);
      return listeners;
    }
  },
  watch: {
    value: function value(val) {
      this.mutableValue = val;
    },
    country: {
      immediate: true,
      handler: function handler(val) {
        this.input();
        if (val) {} else {
          this.mutableValue = null;
        }
      }
    },
    mutableValue: function mutableValue() {
      this.input();
    }
  }
};